import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Calendar, FileText, PenTool, Layout, ListTodo, Hash, Repeat } from 'lucide-react';
export function WhatIncludes() {
  const items = [{
    icon: BookOpen,
    text: 'Ebook completo "El Secreto de la Abundancia"'
  }, {
    icon: Calendar,
    text: 'Calendario 21 días'
  }, {
    icon: FileText,
    text: 'Mapa de creencias (plantilla)'
  }, {
    icon: PenTool,
    text: 'Diario/registro (plantilla)'
  }, {
    icon: ListTodo,
    text: 'Lista de acciones (plantilla)'
  }, {
    icon: Layout,
    text: 'Guía Vision Board por categorías'
  }, {
    icon: Hash,
    text: 'Método 3-6-9'
  }, {
    icon: Repeat,
    text: 'Técnica 55x5'
  }];
  return <section id="incluye" className="py-12 bg-white" data-id="element-220">
      <div className="max-w-5xl mx-auto px-4" data-id="element-221">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2B0A3D] text-center mb-12" data-id="element-222">
          Todo lo que incluye
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-223">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="p-6 rounded-xl bg-[#F8F3EA] border border-[#F8F3EA] hover:border-[#D4AF37]/30 hover:shadow-md transition-all duration-300 flex flex-col items-center text-center gap-4" data-id="element-224">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm text-[#D4AF37]" data-id="element-225">
                <item.icon className="w-6 h-6" data-id="element-226" />
              </div>
              <p className="font-medium text-gray-800 text-sm leading-snug" data-id="element-227">
                {item.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}